// extracted by mini-css-extract-plugin
module.exports = {"bestSeller":"BestSeller_bestSeller__pU8Ha","topRight":"BestSeller_topRight___xaR2","bottomLeft":"BestSeller_bottomLeft__ZAkt2"};